import { Translate } from '@dreryk/react-common';
import { ValidationErrorNotification } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../translations';

export const DosageFrequencyNotAllowedMessage = (): JSX.Element => {
   return (
      <ValidationErrorNotification
         testId={'dosageFrequencyNotAllowed'}
         label={<Translate>{prescriptionTranslationKeys.numericalDosage.dosageFrequencyNotAllowed}</Translate>}
      />
   );
};
